import React from "react";

import PageHeader from "../components/PageHeader";

function BalanceHistory() {
    const history = [
        { id: 1, type: "Пополнение", amount: 2000, date: "29.10.25", positive: true },
        { id: 2, type: "Списание", amount: 150, date: "29.10.25", positive: false },
        { id: 3, type: "Пополнение", amount: 2000, date: "29.10.25", positive: true },
        { id: 4, type: "Пополнение", amount: 2000, date: "29.10.25", positive: true },
        { id: 5, type: "Пополнение", amount: 2000, date: "29.10.25", positive: true },
    ];

    return (
        <>
            <PageHeader title="История баланса" />

            {history.map((item) => (
                <div key={item.id} className="glass-block pad1 relative flex-between">
                    <span className="flex-col">
                        {item.positive ? "✅ Пополнение:" : "🧾 Списание"}
                        <span>
                            <b>
                                {item.positive ? "+" : "-"} {item.amount} руб
                            </b>
                        </span>
                    </span>

                    <span className="date-history absolute">
                        {item.date}г.
                    </span>
                </div>
            ))}
        </>
    );
}

export default BalanceHistory;
